import React, { Component } from "react";
import ReactPlayer from "react-player";
import Modal from "react-responsive-modal";

class Player4 extends Component {
    render() {
        const { open, toggleModal } = this.props;
        return (
            <Modal
                open={open}
                onClose={toggleModal}
                styles={{
                    modal: {
                        maxWidth: "unset",
                        width: "100%",
                        padding: "unset"
                    },
                    overlay: {
                        background: "rgba(0,0,0,0.5)"
                    },
                    closeButton: {
                        background: "green"
                    }
                }}
                center
            >
                <ReactPlayer
                    url="https://youtu.be/gepl1iZB3uQ"
                    width="100%"
                    height="calc(100vh - 100px)"
                />
            </Modal>
        );
    }
}

export default Player4;
